import { render, staticRenderFns } from "./JDJL-order-pay.vue?vue&type=template&id=3f177a9e"
import script from "./JDJL-order-pay.vue?vue&type=script&lang=js"
export * from "./JDJL-order-pay.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports